"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterRelations = void 0;
const MeterRelations_yaml_component_1 = __importDefault(require("./MeterRelations.yaml?component"));
exports.MeterRelations = MeterRelations_yaml_component_1.default;
